import React, { useState } from 'react'
import { postInsertarRangosFormasliquidacion } from '../../../services/Contratacion'
import ModalMensajeCrearRangosFormasDeLiquidacion from './ModalMensajeCrearRangosFormasDeLiquidacion'

const ModalCrearRangosFormasLiquidacion = ({setmodalOnInsertRangosFormasLiquidacion,dataRango,setactualizarDataRangos}) => {
    const [errorSeleccionarTope,seterrorSeleccionarTope]=useState('Seleccionar un Tope')
    const [errorSeleccionarDescripcion,seterrorSeleccionarDescripcion]=useState('Seleccionar una descripción')
    const [errorSeleccionarValor,seterrorSeleccionarValor]=useState('Seleccionar un Valor')
    const [errorSeleccionarCodigoQx,seterrorSeleccionarCodigoQx]=useState('Seleccionar un codigo qx')
    const [modalOnMensajeRangosFormasDeLiquidacion, setmodalOnMensajeRangosFormasDeLiquidacion]=useState(false)
    const [mensajeRangosFormasDeLiquidacion, setmensajeRangosFormasDeLiquidacion]=useState('')
    const [loading,setloading]=useState(false)
    const handleCancelarClick=()=>{
        setmodalOnInsertRangosFormasLiquidacion(false)
    }

    const handleOnsubmitCrearRango=(e)=>{
        e.preventDefault()
        const crearRango={
            'ForLiqCod': dataRango.ForLiqCod,
            'HnrCod':dataRango.HnrCod,
            'TopeiSS': e.target.tope.value,
            'DsciSS': e.target.descripcion.value,
            'FctiSS': e.target.valor.value,
            'ForCoQxR': e.target.codigoQx.value
        }
        setloading(true)
        postInsertarRangosFormasliquidacion(crearRango).then((res)=>{            
            setloading(false)
            if(res.data.success){
                setactualizarDataRangos(crearRango)
                setmodalOnInsertRangosFormasLiquidacion(false)
            }else{
                setmodalOnMensajeRangosFormasDeLiquidacion(true)
                setmensajeRangosFormasDeLiquidacion(res.data.message)
            }
        })
    }

    const handleOnchangeTope=(e)=>{
        if(e.target.value.trim()){
            seterrorSeleccionarTope('')
        }else{
            seterrorSeleccionarTope('Seleccionar un Tope')
        }
    }

    const handleOnchangeDescripcion=(e)=>{
        if(e.target.value.trim()){
            seterrorSeleccionarDescripcion('')
        }else{
            seterrorSeleccionarDescripcion('Seleccionar una descripción')
        }

    }

    const handleOnchangeValor=(e)=>{
        if(e.target.value.trim()){
            seterrorSeleccionarValor('')
        }else{
            seterrorSeleccionarValor('Seleccionar un Valor')
        }

    }

    const handleOnchangeCodigoQx=(e)=>{
        if(e.target.value.trim()){
            seterrorSeleccionarCodigoQx('')
        }else{
            seterrorSeleccionarCodigoQx('Seleccionar un codigo qx')
        }

    }
    
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-2xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Crear liquidacion por Rangos
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            <form onSubmit={handleOnsubmitCrearRango}>
              <div className="flex  text-left">
                
                <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Tope
                  </label>
                  
                  <input
                    onChange={handleOnchangeTope}
                    name='tope'
                    type="number"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarTope}
                  </label>
                  </div>
                  <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Descripción
                  </label>
                  
                  <input
                    onChange={handleOnchangeDescripcion}
                    name='descripcion'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarDescripcion}
                  </label>
                  </div>
                  
              </div>
              <div className="flex  text-left">
                
                <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Valor
                  </label>
                  
                  <input
                    onChange={handleOnchangeValor}
                    name='valor'
                    type="number"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarValor}
                  </label>
                    
                  </div>
                  <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Codigo Qx
                  </label>
                  
                  <input
                    onChange={handleOnchangeCodigoQx}
                    name='codigoQx'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarCodigoQx}
                  </label>
                  </div>
                  
              </div>
            
            
          
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button type="submit"
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button>
          </div>
          </form>
          </div>
        </div>
      </div>
      {loading &&
      <div className="relative flex items-center justify-center h-screen">
      <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
          <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
              <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
              <p className="mt-4 text-lg">Cargando</p>
          </div>
      </div>
      <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
  </div>}
      {modalOnMensajeRangosFormasDeLiquidacion? <ModalMensajeCrearRangosFormasDeLiquidacion setmodalOnMensajeRangosFormasDeLiquidacion={setmodalOnMensajeRangosFormasDeLiquidacion} mensajeRangosFormasDeLiquidacion={mensajeRangosFormasDeLiquidacion}/>:null}
    </div>
  )
}

export default ModalCrearRangosFormasLiquidacion